import React from 'react'

const Zip = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/zip',
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <g fill='none' fillRule='evenodd'>
      <rect fill={primaryColor} x={1} y={1} width='90%' height='90%' rx={2} />
      <g fill={secondaryColor}>
        <path d='M8 1h2v1H8zM10 2h2v1h-2zM8 3h2v1H8zM10 4h2v1h-2zM8 5h2v1H8zM10 6h2v1h-2zM8 7h2v1H8zM10 8h2v1h-2zM8 9h2v1H8z' />
      </g>
      <path
        d='M8 11h4v3.996a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V11zm1 2.996v1h2v-1H9z'
        fill={secondaryColor}
      />
    </g>
  </svg>
)

export default Zip
